import Check from '@mui/icons-material/Check';
import Error from '@mui/icons-material/Error';
import Link from '@mui/icons-material/Link';
import Warning from '@mui/icons-material/Warning';
import { Tooltip, Typography } from '@mui/material';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import ErrorUtil from '@/util/ErrorUtil';
import { ROTA } from '../dominio/Rota';
import HealthCheckResposta from '../util/HealthCheckResposta';
import ReactComponent from './ReactComponent';

class InformacoesAppBackend extends ReactComponent {
    infoBackend = [];
    dependenciasOcultasAcompanhamentoPregao = [
        'DependenciaFotos',
        'DependenciaJobs',
        'DependenciaVariaveisAmbientePlenarioWEB',
        'DependenciaGE',
        'DependenciaValidacaoCPFNaAssinaturaDeDocumentos',
        'DependenciaConfiguracaoJobAlteracaoMinuta',
        'DependenciaVariaveisAmbienteEsijIntegracao',
        'DependenciaVariaveisAmbientePjeIntegracao'
    ];

    async componentDidMount() {
        try {
            await this.carregarInfos();
        } catch (error) {
            console.error(
                `Falha na inicialização do componente InformacoesAppBackend: ${ErrorUtil.getMensagemErro(error)}`
            );
            throw new Error('Falha na inicialização do componente InformacoesAppBackend', { cause: error });
        }
    }

    async carregarInfos() {
        let info = await this.healthCheckService.verificarBackends();

        runInAction(() => {
            this.infoBackend = info;
        });
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            infoBackend: observable,
            carregarInfos: action
        });
    }

    getDataBuildFormatada(dataBuild) {
        return dataBuild.includes('T')
            ? moment(dataBuild.split('T')[0], 'YYYY-MM-DD').format('DD/MM/YYYY')
            : moment(dataBuild, 'DD-MM-YYYY-HH-mm-ss').format('DD/MM/YYYY');
    }

    isDependenciaOcultaAcompanhamentoPregao = (idDetalhe) => {
        return (
            this.dependenciasOcultasAcompanhamentoPregao.findIndex((dependencia) => dependencia === idDetalhe) !== -1
        );
    };

    render() {
        return (
            <ul className="lista-dependencias">
                {this.infoBackend &&
                    this.infoBackend.map((backend) => {
                        return (
                            <li
                                className="item-dependencia"
                                key={this.nextKey}
                            >
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {backend.status && this.renderStatus(backend.status.tipo)}
                                    <Typography
                                        display="inline"
                                        fontWeight="bold"
                                    >
                                        {backend.info.nomeApp}
                                    </Typography>
                                    <Typography
                                        display="inline"
                                        marginLeft="5px"
                                    >
                                        ({this.infoVersao(backend)});
                                    </Typography>
                                    {backend.url && (
                                        <Tooltip title="Detalhes">
                                            <a
                                                href={backend.url}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <Link className="icone" />
                                            </a>
                                        </Tooltip>
                                    )}
                                </span>
                                {this.renderDescricoes(backend)}
                            </li>
                        );
                    })}
            </ul>
        );
    }

    infoVersao(backend) {
        let versao = '';
        versao += backend.info.versaoApp || '';
        versao += ' ' + (backend.info.branchBuild || '');
        versao += ' [build ' + (backend.info.numeroBuild || '?') + ']';
        versao += ' ' + (backend.info.dataBuild ? this.getDataBuildFormatada(backend.info.dataBuild) : '');
        return versao;
    }

    renderStatus(status) {
        if (status === HealthCheckResposta.STATUS_OK) {
            return <Check className="icone icone-ok" />;
        } else if (status === HealthCheckResposta.STATUS_ALERTA) {
            return <Warning className="icone icone-alerta" />;
        } else {
            return <Error className="icone icone-erro" />;
        }
    }

    renderDescricoes(backend) {
        if (!backend.status.detalhes || !backend.status.detalhes.descricoes) {
            return null;
        }

        return backend.status.detalhes.descricoes.map((detalhe, index) => {
            return (
                <ul
                    key={'uldescricoes' + index}
                    style={{ listStyleType: 'none', display: this.isOcultarDetalhe(detalhe) ? 'none' : '' }}
                >
                    {this.renderDetalhe(detalhe)}
                </ul>
            );
        });
    }

    renderDetalhe(detalhe) {
        let iconeStatus = this.renderStatus(detalhe.status.tipo);
        return (
            <li>
                {this.renderIcone(detalhe, iconeStatus)}{' '}
                <Typography
                    display="inline"
                    fontWeight="bold"
                >
                    {detalhe.id}
                </Typography>
            </li>
        );
    }

    renderIcone(detalhe, icone) {
        return this.possuiTextoOuDescricao(detalhe) ? (
            <Tooltip title={detalhe.status.detalhes.texto || detalhe.status.detalhes.descricoes[0].texto || ''}>
                {icone}
            </Tooltip>
        ) : (
            icone
        );
    }

    possuiTextoOuDescricao(detalhe) {
        return detalhe.status.detalhes && (detalhe.status.detalhes.texto || detalhe.status.detalhes.descricoes);
    }

    /**
     * @todo [TODO] Fazer tratamentos específicos para área autenticada e área pública (acompanhamento de pregão).
     * @param {Object} detalhe Objeto com as informações.
     * @returns {boolean} Sinalizador que indica se a informação deve ser ocultada (true) ou não (false).
     */
    isOcultarDetalhe(detalhe) {
        if (window.location.pathname === ROTA.ACOMPANHAMENTO_SESSAO.rota) {
            return this.isDependenciaOcultaAcompanhamentoPregao(detalhe.id);
        }

        if (window.location.pathname === ROTA.TELA_ERRO.rota) {
            return this.isDependenciaOcultaAcompanhamentoPregao(detalhe.id);
        }

        return false;
    }
}

export default inject('stores')(observer(InformacoesAppBackend));
